import apiClient from 'utilities/apiClient';

export const get_activities = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.tracker}/${url}`, payload, true);
};

export const create = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.tracker}/${url}`, payload, true);
};
